import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SecTitle from "../Common/SecTitle";
import { getNews } from "../../services/NewsService";
import PreLoader from "../Common/PreLoader";
var truncate = require("truncate");
const News = () => {
  const [News, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getNewsList();
  }, []);
  const getNewsList = async () => {
    try {
      const data = await getNews();
      if (data.data.State == true) {
        setNews(data.data.Data);
      } else {
      }
    } catch (ex) {}
    setLoading(false);
  };
  if (loading == true) {
    return <PreLoader />;
  } else {
  }
  return News.length !== 0 ? (
    <section className="">
      <div className="container py-5">
        <div className="row ">
          <div className="col-lg-5">
            <div>
              <Link to="/News/index" className="text-center text-muted">
                همه اخبار
              </Link>
            </div>
            <div className="card blur_bg">
              <div className="card-body News_wrapper scroll_style">
                <ul className="p-0">
                  {News
                    ? News.map((item) => (
                        <li key={item.id} className="">
                          <Link to="/News/Index" className="text-dark">
                            {truncate(item.title, 100)}
                          </Link>
                        </li>
                      ))
                    : "داده ای جهت نمایش وجود ندارد"}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-6 d-none d-lg-block">
            <img src="images/svg/News1.svg" alt="" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  ) : null;
};

export default News;
